module.exports = __webpack_public_path__ + "img/产品中心.6fb93d86.png";